export const formatPhoneNumber = (phone) => {
  return phone.replace(/(\+\d{3})(\d{3})(\d{4})/, '$1 $2 $3');
};

export const getInitials = (name) => {
  if (!name && name !== 0) return '';
  const str = String(name).trim();
  if (!str) return '';
  const parts = str.split(' ').filter(Boolean);
  if (parts.length === 1) {
    return parts[0].substring(0, 2).toUpperCase();
  }
  const first = parts[0][0] || '';
  const last = parts[parts.length - 1][0] || '';
  return (first + last).toUpperCase();
};

export const getRandomColor = (id) => {
  const colors = ['#4f46e5', '#059669', '#d97706', '#9333ea', '#e11d48', '#0891b2', '#16a34a', '#dc2626'];
  return colors[id % colors.length];
};

export const calculateSmsCount = (text) => {
  if (!text) return 1;
  return Math.ceil(text.length / 160);
};

export const shouldShowApiToast = (message, isError = false) => {
  if (!message) return false;
  if (isError) return true;
  const lower = String(message).toLowerCase();
  return !(
    lower.includes('retrieved') ||
    lower.includes('retrieving') ||
    lower.includes('retrieval') ||
    lower.includes('fetched') ||
    lower.includes('fetching') ||
    lower.includes('loaded')
  );
};

export const formatDate = (date) => {
  return new Date(date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};